
const SUBSCRIPTION_EMAIL_NOT_VALID = -1;
const SUBSCRIPTION_EMAIL_EXISTS    = -2;
const SUBSCRIPTION_FATAL_ERROR     = -3;
const SUBSCRIPTION_SUCCESS         =  1;
const KLAVIYO_ENDPOINT = "//manage.kmail-lists.com/ajax/subscriptions/subscribe";

const initKlaviyo = () => {
    const customerSubscriptionManager = new CustomerSubscriptionManager();
    const newsletterForms = document.querySelectorAll('form.js-newsletter-subscription-form');

    newsletterForms.forEach(newsletterForm => {
        customerSubscriptionManager.setupForm(newsletterForm);

        const newsletterFormMessage = newsletterForm.querySelector('.js-footer-newsletter-message');

        newsletterForm.addEventListener('subscription:error', (e) => {
            newsletterFormMessage.style.display = 'flex';
            if (e.detail.error.code === SUBSCRIPTION_EMAIL_EXISTS) {
                // MAIL ALREADY EXIST
                newsletterFormMessage.querySelector('span').innerHTML = Shopify.translations.newsletter.newsletter_email_exists;
            } else {
                // ERROR
                newsletterFormMessage.querySelector('span').innerHTML = Shopify.translations.newsletter.newsletter_error;
            }
        });

        newsletterForm.addEventListener('subscription:success', (e) => {
            // OK 
            newsletterFormMessage.style.display = 'flex';
            newsletterFormMessage.querySelector('span').innerHTML = Shopify.translations.newsletter.newsletter_success;
        });
    }); 
}


export default class CustomerSubscriptionManager {
    constructor() {

    }

    setupForm(form, source = null) {
        if(typeof form === "undefined") {
            console.error('form undefined, form cannot be initialized for marketing automation');
        }

        form.addEventListener('submit', e => {
            e.preventDefault();

            const email = form.querySelector('input[name="email"]').value;
            const formData = new FormData(form);

            if(source) {
                formData.set('$source', source);
            }

            if(!CustomerSubscriptionManager.validateEmail(email)) {
                form.dispatchEvent(new CustomEvent('subscription:error', generateEventDetail({
                    error: {
                        code: SUBSCRIPTION_EMAIL_NOT_VALID
                    }
                })));
            } else {
                fetch(form.action, {
                    method: 'post',
                    headers: { 'Access-Control-Allow-Origin' : '*' },
                    body: new FormData(form)
                })
                    .then(response => response.json())
                    .then(json => {
                        if(json.data.is_subscribed === false) {
                            console.log('💌 ' + email + ' has been successfully registered !')
                            form.dispatchEvent(new CustomEvent('subscription:success', generateEventDetail({
                                form: form,
                                success: {
                                    code: SUBSCRIPTION_SUCCESS,
                                    data: json
                                }
                            })));
                        } else {
                            console.log('📧 ' + email + ' already exists into database !')
                            form.dispatchEvent(new CustomEvent('subscription:error', generateEventDetail({
                                form: form,
                                error: {
                                    code: SUBSCRIPTION_EMAIL_EXISTS,
                                    data: json
                                }
                            })));
                        }
                    })
                    .catch(error => {
                        form.dispatchEvent(new CustomEvent('subscription:error', generateEventDetail({
                            form: form,
                            error: {
                                code: SUBSCRIPTION_FATAL_ERROR,
                                data: error
                            }
                        })));
                    });
            }
        })
    }

    static validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    chainExtraPropertiesForFields(extraProperties) {
        return extraProperties.map(property => property.name).join(',');
    }
}

const generateEventDetail = (object) => ({ detail : object });


// ---------------------------------------------------------------------------------------------------------------------
// Init
// ---------------------------------------------------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
    initKlaviyo();
});